import { RESETS } from '../../../api';
import { SendEmailContainer } from '../SendEmailContainer';

export const SendResetPasswordEmail = () => (
  <SendEmailContainer
    emailEndpoint={RESETS}
    header="Forgotten password"
    description="Enter the email address associated with your account, and we’ll send you a link to reset your password."
    sendEmailBtnText={'Send reset link'}
    successfulEmailSentHeader="Password reset link sent"
    successfulEmailSentText="We've sent a password reset link"
  />
);

export default SendResetPasswordEmail;
